import LogoLoading from "./LogoLoading.presenter";
export default LogoLoading;
